import TagManager from 'react-gtm-module';
import BaseTracker from 'trackers/BaseTracker';

class GtmTracker extends BaseTracker {
  tracker: typeof TagManager;

  protected getTracker(): typeof TagManager {
    return super.getTracker();
  }

  constructor() {
    super();
    this.tracker = TagManager;
    this.initialize();
  }

  initialize() {
    if (typeof window === 'undefined') {
      return;
    }

    if (!this.initialized) {
      this.tracker.initialize({
        gtmId: process.env.NEXT_PUBLIC_GTM_ID || '',
        auth: process.env.NEXT_PUBLIC_GTM_AUTH,
        dataLayer: {
          dirittoEnv: process.env.NEXT_PUBLIC_ENVIRONMENT,
        },
      });
      this.initialized = true;
    }
  }

  setUser(userId?: number) {
    this.getTracker().dataLayer({ dataLayer: { userId } });
  }
}

export default GtmTracker;
